export const loginInitStateReducerType = 'loginInitStateReducerType';
export const loginSetIpAddressReducerType = 'loginSetIpAddressReducerType';
export const loginSetLoginFailReducerType = 'loginSetLoginFailReducerType';
export const loginSetIsFormDisabledReducerType = 'loginSetIsFormDisabledReducerType';
export const loginSetIsLoadingReducerType = 'loginSetIsLoadingReducerType';
export const loginSetHasRegistrationReducerType = 'loginSetHasRegistrationReducerType';
export const loginSetHasInstitutionLoginReducerType = 'loginSetHasInstitutionLoginReducerType';
export const loginSetNotificationsReducerType = 'loginSetNotificationsReducerType';
export const loginSetOccurrenceDateReducerType = 'loginSetOccurrenceDateReducerType';
export const loginSetTimestampReducerType = 'loginSetTimestampReducerType';
export const loginSetDataReducerType = 'loginSetDataReducerType';
export const loginReducerKey = 'loginReducerKey';
